<div class="dialog-positioner">
  <div
    #dialog
    class="modal-content"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="labelledBy"
    [attr.aria-label]="labelledBy ? null : accessibleLabel"
    tabindex="-1"
  >
    <ng-content></ng-content>
  </div>
</div>
